exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pay-button{background:tomato;color:#fff;font-size:1.15em;border-radius:4px;height:40px;min-height:40px;max-height:40px;max-width:750px;position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;border:none;vertical-align:top;cursor:pointer;overflow:hidden}.c-grid{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;margin:0 0 1rem}.c-grid__title{margin:0;padding:.25em 0;text-transform:uppercase}.c-grid__item{margin:0 0 .5rem}.u-ml-auto{margin-left:auto}.u-mb-3{margin-bottom:1.5rem}", ""]);

// exports
